import { Routes } from '@angular/router';
import { ShippingChargesComponent } from './shipping-charges/shipping-charges.component';
import { ShippingManagerComponent } from './shipping-manager/shipping-manager.component';

export const ShippingRoutingModule: Routes = [
	{ path: 'shipping-manager', component: ShippingManagerComponent },
	{ path: 'shipping-charges', component: ShippingChargesComponent },
];
